namespace Umbrella.MailProcessing {
    @Pipe('MailProcessing', 'mailAttachmentIsImage')
    class MailAttachmentIsImageFilter {
        public transform = (type: MailAttachmentType) => type === MailAttachmentType.Image;
    }
}
